import React from "react";

import { IAccordionItemContext } from "./accordion-item-context.types";

export default React.createContext<IAccordionItemContext | undefined>(undefined);
